import React, { useState } from 'react';
import { X, Save, AlertTriangle, RefreshCw } from 'lucide-react';
import toast from 'react-hot-toast';
import axios from 'axios';

const AdjustmentModal = ({ isOpen, onClose, itemData, onComplete }) => {
  const [newQty, setNewQty] = useState(itemData?.curbal || 0);
  const [remarks, setRemarks] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSave = async () => {
    setLoading(true);
    try {
      const res = await axios.post('/api/inventory/adjust', {
        itemnum: itemData.itemnum,
        location: itemData.location,
        new_qty: newQty,
        remarks: remarks
      }, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });

      if (res.data.status === 'SUCCESS') {
        toast.success(`Stock Adjusted! Change: ${res.data.adjustment}`);
        onComplete(); // ?????? ???????? ?? ?????? ????????
        onClose();
      } else {
        toast("No changes detected", { icon: '??' });
      }
    } catch (err) {
      toast.error("Adjustment failed: " + (err.response?.data?.detail || "System Error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-md rounded-sm shadow-2xl border-t-4 border-t-orange-600 animate-in zoom-in-95 duration-200 uppercase font-sans">
        
        {/* Header */}
        <div className="p-4 border-b flex justify-between items-center bg-slate-50">
          <h3 className="font-black text-slate-800 text-[10px] tracking-widest flex items-center gap-2">
            <RefreshCw size={14} className="text-orange-600" /> Physical Count Adjustment
          </h3>
          <button onClick={onClose} className="text-slate-400 hover:text-red-500"><X size={18}/></button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-6">
          <div className="flex justify-between items-center bg-blue-50 p-4 border border-blue-100 rounded-sm">
             <div>
                <p className="text-[8px] font-black text-blue-400">Current Book Balance</p>
                <p className="text-xl font-black text-blue-900">{itemData?.curbal} <small className="text-[10px]">{itemData?.orderunit}</small></p>
             </div>
             <div className="text-right">
                <p className="text-[8px] font-black text-blue-400">Variance</p>
                <p className={`text-xl font-black ${(newQty - itemData?.curbal) < 0 ? 'text-red-600' : 'text-green-600'}`}>
                    {(newQty - itemData?.curbal) > 0 ? `+${newQty - itemData?.curbal}` : newQty - itemData?.curbal}
                </p>
             </div>
          </div>

          <div className="space-y-4">
            <div className="flex flex-col gap-1 border-b focus-within:border-orange-500 transition-all">
                <label className="text-[9px] font-black text-gray-400 italic">Actual Physical Count</label>
                <input 
                    type="number" 
                    autoFocus
                    className="outline-none py-2 font-black text-lg text-slate-800"
                    value={newQty}
                    onChange={(e) => setNewQty(e.target.value)}
                />
            </div>

            <div className="flex flex-col gap-1 border-b focus-within:border-orange-500 transition-all">
                <label className="text-[9px] font-black text-gray-400 italic">Adjustment Reason / Remarks</label>
                <textarea 
                    className="outline-none py-2 font-bold text-[10px] h-16 resize-none"
                    placeholder="Why are we changing the stock level?"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                />
            </div>
          </div>

          {Math.abs(newQty - itemData?.curbal) > (itemData?.curbal * 0.2) && (
              <div className="bg-orange-50 border border-orange-200 p-3 rounded-sm flex items-start gap-3">
                  <AlertTriangle className="text-orange-600 shrink-0" size={16}/>
                  <p className="text-[9px] font-bold text-orange-800 lowercase leading-tight">
                    Warning: You are making a significant adjustment (>20% of current stock). Please ensure the physical count is verified.
                  </p>
              </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 bg-slate-50 border-t flex justify-end gap-3">
          <button onClick={onClose} className="px-6 py-2 text-[10px] font-black text-slate-400 hover:text-slate-600 uppercase tracking-widest">Cancel</button>
          <button 
            onClick={handleSave} 
            disabled={loading}
            className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-2 rounded-sm font-black text-[10px] uppercase flex items-center gap-2 shadow-lg transition-all active:scale-95 disabled:opacity-50"
          >
            <Save size={14}/> {loading ? 'Saving...' : 'Post Adjustment'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdjustmentModal;